import { type MutationTree } from 'vuex';

import { type IInternalContactAllianceState } from './types';

export const RECEIVE_BY_ALLIANCE = 'receiveByAlliance';

export const mutations: MutationTree<IInternalContactAllianceState> = {
    [RECEIVE_BY_ALLIANCE](_state: IInternalContactAllianceState, { allianceId, idList }: { allianceId: number; idList: number[] }) {
        _state.byAlliance.set(allianceId, idList);
    }
};
